import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// Redux
import { connect } from 'react-redux';
// Redux Form
import { Field, reduxForm, formValueSelector } from 'redux-form';
// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Calendar.css';
/* import dp from 'react-day-picker/lib/style.css'; */
import bt from '../../../components/commonStyle.css';
import {
  Row,
  Col,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
} from 'react-bootstrap';
import cx from 'classnames';
// Translation
import { injectIntl, FormattedMessage } from 'react-intl';

// Locale
import messages from '../../../locale/messages';
// Redux action
import { bookingProcess } from '../../../actions/booking/bookingProcess';
// Component
/* import moment from 'moment'; */
/* import DayPicker, { DateUtils } from 'react-day-picker'; */
import MonthlyPassStartDayPicker from '../MonthlyPassStartDayPicker';
import MonthPassRange from '../MonthPassRange';
import DateRange from '../DateRange';
import CustomCheckbox from '../../CustomCheckbox/CustomCheckbox';
import BillDetails from './BillDetails';
import BookingButton from './BookingButton';
import CurrencyConverter from '../../CurrencyConverter';

import pMath from '../../../helpers/pMath';
import bookingCalculations from '../../../helpers/bookingCalculations';

import { locale } from 'core-js';

class BookingForm extends Component {
  static propTypes = {
    onChange: PropTypes.any,
    id: PropTypes.number.isRequired,
    personCapacity: PropTypes.number.isRequired,
    country: PropTypes.string,
    basePrice: PropTypes.number.isRequired,
    cleaningPrice: PropTypes.number,
    currency: PropTypes.string,
    monthlyDiscount: PropTypes.number,
    weeklyDiscount: PropTypes.number,
    minNight: PropTypes.number,
    maxNight: PropTypes.number,
    maxDaysNotice: PropTypes.string,
    loading: PropTypes.bool,
    availability: PropTypes.bool,
    specialPricing: PropTypes.array,
    isHotDesking: PropTypes.bool,
    isOpenOnWeekends: PropTypes.bool,
    freeTrialDays: PropTypes.number,
    maximumStay: PropTypes.bool,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    blockedDates: PropTypes.array,
    isHost: PropTypes.bool.isRequired,
    guests: PropTypes.number,
    serviceFees: PropTypes.shape({
      guest: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    base: PropTypes.string.isRequired,
    rates: PropTypes.object.isRequired,
    bookingType: PropTypes.string.isRequired,
    bookingLoading: PropTypes.bool,
    formatMessage: PropTypes.any,
    account: PropTypes.shape({
      userBanStatus: PropTypes.number,
    })
  };
  static defaultProps = {
    specialPricing: [],
    isHotDesking: false,
    isOpenOnWeekends: false,
    freeTrialDays: 0,
    blockedDates: [],
    availability: true,
    maximumStay: false,
    minimumStay: false,
    startDate: null,
    endDate: null,
    guests: 1,
    personCapacity: 0,
    country: ''
  };

  constructor(props) {
    super(props);
    this.state = {
      maxCapacity: props.personCapacity
    };
    this.handleDatesChange = this.handleDatesChange.bind(this);
  }

  renderFormControlSelect({ input, label, meta: { touched, error }, children, className }) {
    return (
      <div>
        <FormControl componentClass="select" {...input} className={className} >
          {children}
        </FormControl>
      </div>
    );
  }
  renderGuests(personCapacity) {
    const { formatMessage } = this.props.intl;
    const rows = [];
    for (let i = 1; i <= personCapacity; i++) {
      rows.push(<option key={i} value={i}>{i} {i > 1 ? formatMessage(messages.guests) : formatMessage(messages.guest)}</option>);
    }
    return rows;
  }

  monthPassCheckbox = ({ input }) => (
    <CustomCheckbox
      name={input.name}
      className={'icheckbox_square-green'}
      value="1"
      checked={input.value == "1"}
      onChange={event => {
        return input.onChange(event === true ? "1" : "0");
      }}
    />
  );

  freeTrialCheckbox = ({ input }) => (
    <React.Fragment>
      <CustomCheckbox
        name={input.name}
        className={'icheckbox_square-green'}
        value="1"
        checked={input.value == "1"}
        onChange={event => {
          return input.onChange(event === true ? "1" : "0");
        }}
      />
      <span className={cx(s.checkBoxLabel)}>
        <FormattedMessage {...messages.useFreeTrial} />
      </span>
    </React.Fragment>
  );
  
  handleDatesChange(maxCapacity) {
    this.setState({maxCapacity: maxCapacity});
  }
  
  render() {
    const { formatMessage } = this.props.intl;
    const { id, personCapacity, basePrice, promoPrice, cleaningPrice, currency, isHost, bookingType, taxRate, isHotDesking, isOpenOnWeekends, isSample, freeTrialDays } = this.props;
    const { monthlyDiscount, monthlyPassPrice, monthlyPassPromoPrice, monthPassPrice, monthlyPass, monthPass, weeklyDiscount, minNight, maxNight, maxDaysNotice } = this.props;
    const { isLoading, availability, maximumStay, guests, useFreeTrial, startDate, endDate, account, blockedDates, closedOnWeekends, minimumStay, country, locale } = this.props;
    const { bookingProcess, serviceFees, base, rates, bookingLoading, initialValues } = this.props;
    const isDateChosen = startDate != null && (monthlyPass || endDate != null);
    const { profile: { companyName, displayName } } = this.props;
    const { dispatch } = this.props;
    const { projectTicketmaster } = this.props;
    const { smallDevice } = this.props;
    const { specialPricing } = this.props;
    const { maxCapacity } = this.state;

    let hostName = companyName ? companyName : displayName;

    let userBanStatusValue;
    if (account) {
      const { account: { userBanStatus } } = this.props;
      userBanStatusValue = userBanStatus;
    }

    let taxAmount = 0;
    let promoDays = 0;

    let monthlyPassSavings = 0;
    let monthlyPassSubTotal = 0;
    let monthlyPassPromoSubTotal = 0;
    let monthlyPassTaxAmount = 0;
    let monthlyPassTotal = 0;
    if( monthlyPassPrice ) {
      ({ monthlyPassSavings, monthlyPassSubTotal, monthlyPassPromoSubTotal, monthlyPassTaxAmount, monthlyPassTotal } = bookingCalculations.monthlyPass({basePrice, isOpenOnWeekends, monthlyPass, monthlyPassPrice, monthlyPassPromoPrice, isHotDesking, guests, taxRate}));
      taxAmount = monthlyPassTaxAmount;
      /* let monthlyPriceAtDayRate = basePrice * (isOpenOnWeekends ? 30.4 : 21.6);
      if( monthlyPriceAtDayRate > monthlyPassPrice ) {
        monthlyPassSavings = pMath.round(monthlyPriceAtDayRate - monthlyPassPrice);
      }
      if( monthlyPass ) {
        monthlyPassSubTotal = isHotDesking ? pMath.round(monthlyPassPrice * guests) : monthlyPassPrice;
        
        if( taxRate ) {
          monthlyPassTaxAmount = pMath.round(monthlyPassSubTotal * taxRate / 100);
        }

        monthlyPassTotal = pMath.round(monthlyPassSubTotal + monthlyPassTaxAmount);
      } */
    }

    let monthPassSavings = 0;
    let monthPassSubTotal = 0;
    let monthPassTaxAmount = 0;
    let monthPassTotal = 0;
    if( monthPassPrice ) {
      ({ monthPassSavings, monthPassSubTotal, monthPassTaxAmount, monthPassTotal } = bookingCalculations.monthPass({basePrice, isOpenOnWeekends, monthPass, monthPassPrice, isHotDesking, guests, taxRate}));
      taxAmount = monthPassTaxAmount;
      /* let monthPriceAtDayRate = basePrice * (isOpenOnWeekends ? 30.4 : 21.6);
      if( monthPriceAtDayRate > monthPassPrice ) {
        monthPassSavings = pMath.round(monthPriceAtDayRate - monthPassPrice);
      }
      if( monthPass ) {
        monthPassSubTotal = isHotDesking ? pMath.round(monthPassPrice * guests) : monthPassPrice;
        
        if( taxRate ) {
          monthPassTaxAmount = pMath.round(monthPassSubTotal * taxRate / 100);
        }

        monthPassTotal = pMath.round(monthPassSubTotal + monthPassTaxAmount);
      } */
    }

    ({ taxAmount, promoDays } = bookingCalculations.standardBooking({
      basePrice,
      promoPrice,
      cleaningPrice,
      currency,
      monthlyDiscount,
      weeklyDiscount,
      startDate,
      endDate,
      serviceFees,
      base,
      rates,
      specialPricing,
      taxRate,
      isHotDesking,
      isOpenOnWeekends,
      freeTrialDays,
      guests,
      useFreeTrial,
      projectTicketmaster,
      formatMessage
    }));

    moment.locale(locale);

    return (
      <Form>
        {
        (monthlyPassPrice) && <FormGroup>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className={cx(s.monthPass)}>
                <div className={cx(s.monthPassLabel)}>{formatMessage(messages.monthlyPassLabel).split('[[price]]').map((e, i) => {
                  //return i ? e : [e, <span style={(monthlyPassPromoPrice) ? { textDecoration: 'line-through' } : {}}><CurrencyConverter amount={monthlyPassPrice} from={currency} /></span>, ...(monthlyPassPromoPrice) ? [<span style={{color: '#E8505B'}}> <CurrencyConverter amount={monthlyPassPromoPrice} from={currency} /></span>] : []];
                  return i ? e : [e, <CurrencyConverter amount={monthlyPassPrice} from={currency} />];
                })}{ monthlyPassSavings > 0 && <span>, <FormattedMessage {...messages.monthPassSavingApproxLabel} /> <CurrencyConverter amount={monthlyPassSavings} from={currency} /></span>}?{(monthlyPassPromoPrice) && <span style={{color: '#E8505B'}}> (<FormattedMessage {...messages.firstMonth} /> <CurrencyConverter amount={monthlyPassPromoPrice} from={currency} />)</span>}</div>
                <Field name="monthlyPass" component={this.monthPassCheckbox} />
              </div>
            </Col>
          </Row>
        </FormGroup>
        }
        {
        (!monthlyPassPrice && monthPassPrice) && <FormGroup>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className={cx(s.monthPass)}>
                <div className={cx(s.monthPassLabel)}>{formatMessage(messages.monthPassLabel).split('[[price]]').map((e, i) => {
                  return i ? e : [e, <CurrencyConverter amount={monthPassPrice} from={currency} />];
                })}{ monthPassSavings > 0 && <span>, <FormattedMessage {...messages.monthPassSavingApproxLabel} /> <CurrencyConverter amount={monthPassSavings} from={currency} /></span>}?</div>
                <Field name="monthPass" component={this.monthPassCheckbox} />
              </div>
            </Col>
          </Row>
        </FormGroup>
        }
        { monthlyPassPrice && monthlyPass ? <FormGroup className={s.formGroup}>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} className={s.positionR}>
                <label className={s.inputLabelText}>
                  <FormattedMessage {...messages.selectMonthlyPassStartDateLabel} />
                </label>
                <MonthlyPassStartDayPicker
                  formName={'BookingForm'}
                  isOpenOnWeekends={isOpenOnWeekends}
                  smallDevice={smallDevice}
                  dispatch={dispatch}
                />
              </Col>
            </Row>
          </FormGroup> : ( monthPassPrice && monthPass ? <React.Fragment>
            <FormGroup className={s.formGroup}>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12} className={s.positionR}>
                  <label className={s.inputLabelText}>
                    <FormattedMessage {...messages.selectMonthPassStartDateLabel} />
                  </label>
                  <MonthPassRange
                    listId={id}
                    blockedDates={blockedDates}
                    formName={'BookingForm'}
                    country={country}
                    isHotDesking={isHotDesking}
                    isOpenOnWeekends={isOpenOnWeekends}
                    guests={guests}
                    maxCapacity={personCapacity}
                    handleDatesChange={this.handleDatesChange}
                    dispatch={dispatch}
                    smallDevice={smallDevice}
                  />
                </Col>
              </Row>
          </FormGroup>
        { (endDate) && <FormGroup className={s.formGroup}>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} className={s.positionR}>
                <div className={s.monthPass}><FormattedMessage {...messages.monthPassWillEnd} /> {endDate.format('L')}</div>
              </Col>
            </Row>
          </FormGroup> }
        </React.Fragment>
        : ( !monthlyPassPrice || !monthlyPass ) &&
        <FormGroup className={s.formGroup}>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} className={s.positionR}>
              <label className={s.inputLabelText}>
                <FormattedMessage {...messages.selectADateLabel} />
              </label>
              <span className={cx('viewListingDate')}>
                <DateRange
                  listId={id}
                  minimumNights={minNight}
                  maximumNights={maxNight}
                  blockedDates={blockedDates}
                  formName={'BookingForm'}
                  maxDaysNotice={maxDaysNotice}
                  country={country}
                  isHotDesking={isHotDesking}
                  isOpenOnWeekends={isOpenOnWeekends}
                  guests={guests}
                  maxCapacity={personCapacity}
                  handleDatesChange={this.handleDatesChange}
                />
              </span>
            </Col>
          </Row>
        </FormGroup>
        )}
        {
          isHotDesking == true && <FormGroup>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <label className={cx(s.inputLabelText, s.inputLabelWorkspaces)}><FormattedMessage {...messages.workSpacesNonAssigned} /></label>
              <Field
                name="guests"
                component={this.renderFormControlSelect}
                className={cx(s.formControlSelect, bt.commonControlSelect, 'viewGuestCount')}
                //onChange={(e) => this.onGuestsChange(e)}
              >
                {this.renderGuests(maxCapacity)}
              </Field>
            </Col>
          </Row>
        </FormGroup>
        }
        {
          (freeTrialDays > 0 && !monthlyPass && !monthPass) && <FormGroup>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Field name="useFreeTrial" component={this.freeTrialCheckbox} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className={cx(s.useFreeTrialNote)}>{formatMessage(messages.useFreeTrialNote).replace('[[usersHave]]', !isHotDesking || guests > 1 ? formatMessage(messages.useFreeTrialNoteUsersHavePlural) : formatMessage(messages.useFreeTrialNoteUsersHaveSingular))}</div>
            </Col>
          </Row>
        </FormGroup>
        }
        <FormGroup>
          <div className={s.hostSectionGrid}>
            <div className={s.host}>{hostName}</div>
            <div className={s.textAlignRight}>
              <div className={s.priceText}>
              {
                !monthlyPass && !monthPass && promoPrice && <span style={{textDecoration: 'line-through'}}>
                <CurrencyConverter
                  amount={basePrice*(isHotDesking ? guests : 1)}
                  className={s.priceText}
                  from={currency}
                />
                &nbsp;</span>
              }
              {
                <CurrencyConverter
                  amount={(monthlyPass ? monthlyPassPrice : (monthPass ? monthPassPrice : (promoPrice ? promoPrice : basePrice)))*(isHotDesking ? guests : 1)}
                  className={!monthlyPass && !monthPass && promoPrice ? s.promoPrice : s.priceText}
                  from={currency}
                />
              }{!monthlyPass && !monthPass && promoPrice && <span className={s.promoPrice}>*</span>}{' '}{ taxRate > 0 && <span className={s.plusVAT}>+ <FormattedMessage {...messages.VAT} /></span> }
                <span className={s.listingItem}>
                  <FormattedMessage {...(monthlyPass || monthPass ? messages.perMonthLabel : messages.searchListingDayLabel)} />
                </span>
              </div>
            </div>
          </div>
        </FormGroup>
        <FormGroup>
          {
            !isLoading && maximumStay && isDateChosen && !userBanStatusValue && <div className={cx(s.bookItMessage, s.spaceTop3)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.maximumStay} /> {maxNight+1} {maxNight > 0 ? formatMessage(messages.nights) : formatMessage(messages.night)}
              </p>
            </div>
          }
          {
            !isLoading && closedOnWeekends && isDateChosen && !userBanStatusValue && <div
              className={cx(s.bookItMessage, s.spaceTop3)}
            >
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.closedOnWeekends} />
              </p>
            </div>
          }
          {
            !isLoading && minimumStay && isDateChosen && !userBanStatusValue && <div
              className={cx(s.bookItMessage, s.spaceTop3)}
            >
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.minimumNightStay} />  {minNight+1} {minNight > 0 ? formatMessage(messages.nights) : formatMessage(messages.night)}
              </p>
            </div>
          }

          {
            !isLoading && !availability && isDateChosen && !userBanStatusValue && <div className={cx(s.bookItMessage, s.spaceTop3)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.hostErrorMessage2} />
              </p>
            </div>
          }
        </FormGroup>
        {
          !maximumStay && !closedOnWeekends && !minimumStay && availability && isDateChosen && !userBanStatusValue && ( monthlyPassPrice && monthlyPass ?
            <FormGroup>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <table className={cx('table')}>
                    <tbody>
                      { (monthlyPassPromoPrice) && 
                      <tr className={cx(s.positionR)}>
                        <td className={cx(s.noBorder)}>
                          <div className={cx(s.specialPriceText, 'directionLtr')}>
                            <span>{formatMessage(messages.firstMonth)}...</span>
                          </div>
                        </td>
                      </tr>}
                      <tr className={cx(s.positionR)}>
                        <td className={cx(s.noBorder)}>
                          <div className={cx(s.specialPriceText, 'directionLtr')} style={(monthlyPassPromoPrice) ? { textDecoration: 'line-through' } : {}}>
                            <CurrencyConverter
                                amount={monthlyPassPrice}
                                from={currency}
                            />
                            { isHotDesking == true && <span>
                                {' x'} {guests} {guests > 1 ? formatMessage(messages.guests) : formatMessage(messages.guest)}
                            </span> }
                          </div>
                        </td>
                        <td className={cx(s.noBorder, 'text-right')} style={(monthlyPassPromoPrice) ? { textDecoration: 'line-through' } : {}}>
                          <CurrencyConverter
                            amount={monthlyPassSubTotal}
                            from={currency}
                          />
                        </td>
                      </tr>
                      { (monthlyPassPromoPrice) && <tr className={cx(s.positionR, s.promoPrice)}>
                        <td className={cx(s.noBorder)}>
                          <div className={cx(s.specialPriceText, 'directionLtr')}>
                            <CurrencyConverter
                                amount={monthlyPassPromoPrice}
                                from={currency}
                            />
                            { isHotDesking == true && <span>
                                {' x'} {guests} {guests > 1 ? formatMessage(messages.guests) : formatMessage(messages.guest)}
                            </span> }
                          </div>
                        </td>
                        <td className={cx(s.noBorder, 'text-right')}>
                          <CurrencyConverter
                            amount={monthlyPassPromoSubTotal}
                            from={currency}
                          />
                        </td>
                      </tr>}
                      {
                      monthlyPassTaxAmount > 0 && <React.Fragment>
                      {/* <tr>
                        <td><FormattedMessage {...messages.subTotal} /></td>
                        <td className={cx('text-right')}>
                          <CurrencyConverter
                            amount={monthlyPassSubTotal}
                            from={currency}
                          />
                        </td>
                      </tr> */}
                      <tr>
                        <td><FormattedMessage {...messages.VAT} /> @{taxRate}%</td>
                        <td className={cx('text-right')}>
                          <CurrencyConverter
                            amount={monthlyPassTaxAmount}
                            from={currency}
                          />
                        </td>
                      </tr>
                      </React.Fragment>
                      }
                      <tr>
                        <td><FormattedMessage {...messages.total} /></td>
                        <td className={cx('text-right')}>
                          <CurrencyConverter
                            amount={monthlyPassTotal}
                            from={currency}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            </FormGroup>
          : ( monthPassPrice && monthPass ?
            <FormGroup>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <table className={cx('table')}>
                    <tbody>
                      <tr className={cx(s.positionR)}>
                        <td className={cx(s.noBorder)}>
                          <div className={cx(s.specialPriceText, 'directionLtr')}>
                            <CurrencyConverter
                                amount={monthPassPrice}
                                from={currency}
                            />
                            { isHotDesking == true && <span>
                                {' x'} {guests} {guests > 1 ? formatMessage(messages.guests) : formatMessage(messages.guest)}
                            </span> }
                          </div>
                        </td>
                        <td className={cx(s.noBorder, 'text-right')}>
                          <CurrencyConverter
                            amount={monthPassSubTotal}
                            from={currency}
                          />
                        </td>
                      </tr>
                      {
                      monthPassTaxAmount > 0 && <React.Fragment>
                      {/* <tr>
                        <td><FormattedMessage {...messages.subTotal} /></td>
                        <td className={cx('text-right')}>
                          <CurrencyConverter
                            amount={monthPassSubTotal}
                            from={currency}
                          />
                        </td>
                      </tr> */}
                      <tr>
                        <td><FormattedMessage {...messages.VAT} /> @{taxRate}%</td>
                        <td className={cx('text-right')}>
                          <CurrencyConverter
                            amount={monthPassTaxAmount}
                            from={currency}
                          />
                        </td>
                      </tr>
                      </React.Fragment>
                      }
                      <tr>
                        <td><FormattedMessage {...messages.total} /></td>
                        <td className={cx('text-right')}>
                          <CurrencyConverter
                            amount={monthPassTotal}
                            from={currency}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            </FormGroup>
            :
            <BillDetails
              basePrice={basePrice}
              promoPrice={promoPrice}
              promoDays={promoDays}
              cleaningPrice={cleaningPrice}
              currency={currency}
              monthlyDiscount={monthlyDiscount}
              weeklyDiscount={weeklyDiscount}
              startDate={startDate}
              endDate={endDate}
              serviceFees={serviceFees}
              base={base}
              rates={rates}
              taxRate={taxRate}
              isHotDesking={isHotDesking}
              isOpenOnWeekends={isOpenOnWeekends}
              freeTrialDays={freeTrialDays}
              guests={guests}
              useFreeTrial={useFreeTrial}
              projectTicketmaster={projectTicketmaster}
            />
            )
          )
        }
        {
          !monthlyPass && !monthPass && promoPrice && <p className={cx(s.testListingNotice)}>
          <FormattedMessage {...messages.promoPriceRestriction} />
        </p>
        }
        {
          isSample == true && <p className={cx(s.testListingNotice)}>
            <FormattedMessage {...messages.testListingNotice} />
          </p>
        }
        <BookingButton
          listId={id}
          projectTicketmaster={projectTicketmaster}
          startDate={startDate}
          endDate={endDate}
          guests={!isNaN(guests) ? guests : 1}
          useFreeTrial={useFreeTrial}
          monthlyPass={monthlyPass}
          monthPass={monthPass}
          bookingProcess={bookingProcess}
          availability={availability}
          isDateChosen={isDateChosen}
          userBanStatus={userBanStatusValue}
          basePrice={basePrice}
          isHost={isHost}
          bookingType={bookingType}
          bookingLoading={bookingLoading}
          maximumStay={maximumStay}
          taxRate={taxRate}
          taxAmount={taxAmount}
          minimumStay={minimumStay}
          closedOnWeekends={closedOnWeekends}
        />
      </Form>
    );
  }
}
BookingForm = reduxForm({
  form: 'BookingForm', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(BookingForm);
// Decorate with connect to read form values
const selector = formValueSelector('BookingForm'); // <-- same as form name
const mapState = state => ({
  locale: state.intl.locale,
  isLoading: state.viewListing.isLoading,
  specialPricing: state.viewListing.specialPricing,
  availability: state.viewListing.availability,
  maximumStay: state.viewListing.maximumStay,
  minimumStay: state.viewListing.minimumStay,
  closedOnWeekends: state.viewListing.closedOnWeekends,
  monthlyPass: selector(state, 'monthlyPass') == '1',
  monthPass: selector(state, 'monthPass') == '1',
  startDate: selector(state, 'startDate'),
  endDate: selector(state, 'endDate'),
  guests: Number(selector(state, 'guests')),
  useFreeTrial: selector(state, 'useFreeTrial') == '1',
  account: state.account.data,
  serviceFees: state.book.serviceFees,
  base: state.currency.base,
  rates: state.currency.rates,
  bookingLoading: state.book.bookingLoading,
});
const mapDispatch = {
  bookingProcess,
};
export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(BookingForm)));


// WEBPACK FOOTER //
// src/components/ViewListing/Calendar/BookingForm.js